import axios from "axios";

const BASE_URL = "api/v2/user-mfa-devices";

function setupHeaders(setupToken) {
  return setupToken ? { "X-MFA-Setup-Token": setupToken } : undefined;
}

export function createDevice({ name, password, setupToken }) {
  return axios.post(BASE_URL, { name, password }, { headers: setupHeaders(setupToken) });
}

export function verifyDevice(deviceId, code, setupToken) {
  return axios.post(
    `${BASE_URL}/${deviceId}/verify`,
    { code },
    { headers: setupHeaders(setupToken) }
  );
}

export function getDevices() {
  return axios.get(BASE_URL);
}

export function revokeDevice(deviceId) {
  return axios.delete(`${BASE_URL}/${deviceId}`);
}

export function regenerateRecoveryCodes(password, code) {
  return axios.post(`${BASE_URL}/backup-codes/regenerate`, { password, code });
}

export function getMfaNotice() {
  return axios.get("api/v2/users/mfa-notice");
}
